import React from "react";
import shortid from "shortid";

const fillStar = (percent) => {
  const id = shortid.generate();
  switch (percent) {
    case "zero":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline zero" aria-hidden="true"></i>
        </i>
      );
    case "ten":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline ten" aria-hidden="true"></i>
        </i>
      );
    case "twenty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline twenty" aria-hidden="true"></i>
        </i>
      );
    case "thirty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline thirty" aria-hidden="true"></i>
        </i>
      );
    case "forty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline forty" aria-hidden="true"></i>
        </i>
      );
    case "fifty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline fifty" aria-hidden="true"></i>
        </i>
      );
    case "sixty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline sixty" aria-hidden="true"></i>
        </i>
      );
    case "seventy":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline seventy" aria-hidden="true"></i>
        </i>
      );
    case "eighty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline eighty" aria-hidden="true"></i>
        </i>
      );
    case "ninty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline ninty" aria-hidden="true"></i>
        </i>
      );
    case "hundred":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline hundred" aria-hidden="true"></i>
        </i>
      );
    default:
      return "";
  }
};
const fillStarWitoutO = (percent) => {
  const id = shortid.generate();
  switch (percent) {
    case "zero":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline zero" aria-hidden="true"></i>
        </i>
      );
    case "ten":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline ten" aria-hidden="true"></i>
        </i>
      );
    case "twenty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline twenty" aria-hidden="true"></i>
        </i>
      );
    case "thirty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline thirty" aria-hidden="true"></i>
        </i>
      );
    case "forty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline forty" aria-hidden="true"></i>
        </i>
      );
    case "fifty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline fifty" aria-hidden="true"></i>
        </i>
      );
    case "sixty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline sixty" aria-hidden="true"></i>
        </i>
      );
    case "seventy":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline seventy" aria-hidden="true"></i>
        </i>
      );
    case "eighty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline eighty" aria-hidden="true"></i>
        </i>
      );
    case "ninty":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline ninty" aria-hidden="true"></i>
        </i>
      );
    case "hundred":
      return (
        <i className="fa fa-star-o" aria-hidden="true" key={id}>
          <i className="fa fa-star outline hundred" aria-hidden="true"></i>
        </i>
      );
    default:
      return "";
  }
};
const RatingStart = (props) => {
  return (
    <React.Fragment>
      {props.withoutO ? (
        !props.inline ? (
          <div
            className={
              props.star ? "star" : props.profile ? "starIcon" : "star"
            }
          >
            {props.starCount.length > 0
              ? props.starCount.map(
                  (count) => !!count && fillStarWitoutO(count.percent)
                )
              : null}
          </div>
        ) : (
          <React.Fragment>
            {props.starCount.length > 0
              ? props.starCount.map(
                  (count) => !!count && fillStarWitoutO(count.percent)
                )
              : null}
          </React.Fragment>
        )
      ) : !props.inline ? (
        <div
          className={props.star ? "star" : props.profile ? "starIcon" : "star"}
        >
          {props.starCount.length > 0
            ? props.starCount.map((count) => !!count && fillStar(count.percent))
            : null}
        </div>
      ) : (
        <React.Fragment>
          {props.starCount.length > 0
            ? props.starCount.map((count) => !!count && fillStar(count.percent))
            : null}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default RatingStart;
